import { render, staticRenderFns } from "./CheckoutRedeem.vue?vue&type=template&id=8fb5f8a6"
import script from "./CheckoutRedeem.vue?vue&type=script&lang=js"
export * from "./CheckoutRedeem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports